import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {array, bool, func, number, object, oneOfType, string} from "prop-types";
import Text from "features/components/text";
import {get, xor} from "lodash";
import {withTranslation} from "react-i18next";
import {Icon} from "features/components/icon";
import {useOnClickOutside} from "services/utils/utils";

export const ChipSelector = (props) => {
    const value = props.value || [];
    const {placeholder, data = [], enableAddSearched, onChange, t, maxItems, disabled} = props;
    const [search, setSearch] = useState("");

    const dataFiltered = useMemo(() => {
        const toSearch = search.toLowerCase();
        let dataToSearch = data.filter(i => !!i.key);
        if(!!enableAddSearched && !dataToSearch.map(i => i.key).includes(search)) {
            let searched = {key: search, value: search};
            dataToSearch = [searched, ...dataToSearch];
        }
        return dataToSearch
            .filter(i => !value.includes(i.key))
            .filter(i => i.key.toLowerCase().includes(toSearch) || i.value.toLowerCase().includes(toSearch));
    }, [data, search, enableAddSearched, value]);

    const toggleChip = useCallback((val) => {
        if(!maxItems || value.length < maxItems) {
            onChange(xor(value, [val]));
            setSearch("");
        }
    }, [onChange, value, maxItems]);
    const removeChip = useCallback((val) => {
        onChange(xor(value, [val]));
    }, [onChange, value]);

    const [isFocused, setFocused] = useState(false);

    const keyDownCallback = useCallback(event => {
        if (event.key === "Enter" && dataFiltered.length > 0) {
               toggleChip(dataFiltered[0].key);
        }
    }, [dataFiltered, toggleChip]);

    const outsideRef = React.useRef(null);
    /*istanbul ignore next*/
    useOnClickOutside(outsideRef, () => {
        setFocused(false);
    })

    return <div ref={outsideRef} className={`chip-selector ${!!disabled ? 'disabled' : ''}`}>
        <div className="chip-input">{(placeholder && !search) && <span className="placeholder">{placeholder}</span>}
            <input disabled={!!disabled}
                   type="text"
                   value={search}
                   onFocus={() => setFocused(true)}
                   onChange={event => setSearch(event.target.value)}
                   onKeyDown={keyDownCallback}
            />
            {isFocused && dataFiltered.length > 0 && <div className={"result"}>
                {dataFiltered.map(i =>
                    <div
                        key={i.key}
                        onClick={() => {
                            toggleChip(i.key);
                            setFocused(false);
                        }}
                    >
                        <Text size={16}>{t(i.value)}</Text>
                    </div>)}
            </div>}
        </div>
        {value.length > 0 && <div className="selection">
            {value.map(i => <div key={i} onClick={() => removeChip(i)}>
                {t(get(data.find(item => item.key === i), 'value', i))}
                <Icon>clear-circle-outlined</Icon>
            </div>)}
        </div>}
    </div>

};
ChipSelector.propTypes = {
    placeholder: oneOfType([string, object]),
    data: array.isRequired,
    enableAddSearched: bool,
    value: array,
    onChange: func.isRequired,
    maxItems: number,
    disabled: bool
};
export default withTranslation()(ChipSelector);